import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ContentState {
	drawer: boolean
	moduleOpened: Array<number>
}

const initialState: ContentState = {
	drawer: false,
	moduleOpened: [],
}

export const contentSlice = createSlice({
	name: 'content',
	initialState,
	reducers: {
		setDrawer: (
			state,
			{ payload: { drawer } }: PayloadAction<{ drawer: boolean }>
		) => {
			state.drawer = drawer
		},
		setOrRemove: (
			state,
			{ payload: { idx } }: PayloadAction<{ idx: number }>
		) => {
			if (state.moduleOpened?.includes(idx)) {
				state.moduleOpened = state.moduleOpened?.filter(
					(index) => index !== idx
				)
			} else {
				state.moduleOpened = [...(state.moduleOpened || []), idx]
			}
		},
		reset: (state) => {
			state.moduleOpened = initialState.moduleOpened
		},
	},
})

export const contentCreators = contentSlice.actions

export const contentReducer = contentSlice.reducer
